namespace app.services {
  import IHttpService = angular.IHttpService;
  import IRequestConfig = angular.IRequestConfig;
  import IHttpPromise = angular.IHttpPromise;

  export interface IHttpWrapperService {
    $http<T = any>(config: IRequestConfig): IHttpPromise<T>;
    $ajax(url: string, config?: any): any;
  }

  export class HttpService implements IHttpWrapperService {
    private http: IHttpService;
    private configService: IConfigService;
    private tokenService: app.services.authentication.TokenService;

    constructor(
      $http: IHttpService,
      configService: IConfigService,
      tokenService: app.services.authentication.TokenService
    ) {
      this.http = $http;
      this.configService = configService;
      this.tokenService = tokenService;
    }

    $http<T = any>(config: IRequestConfig): IHttpPromise<T> {
      const tokenParams = {
        client_id: this.configService.getClientId(),
        access_token: this.tokenService.GetAccessToken()
      };
      config.params = angular.extend({}, tokenParams, config.params || {});
      return this.http(config);
    }

    $ajax(url: string, config?: any): any {
      const tokenParams = {
        client_id: this.configService.getClientId(),
        access_token: this.tokenService.GetAccessToken()
      };
      const parts = url.split('?');
      const params = parts.length > 1 ? parts[1] : '';

      if (params !== '') {
        url = parts[0] + '?' + params + '&' + $.param(tokenParams);
      } else {
        url += '?' + $.param(tokenParams);
      }

      return $.ajax(url, config);
    }
  }

  frontendApp.factory('HttpService', ['$http', 'ConfigService', 'TokenService',
    function($http: IHttpService, configService: IConfigService, tokenService: app.services.authentication.TokenService) {
      return new HttpService($http, configService, tokenService);
    }
  ]);

}
